import React from "react";
import { LOGO_NASA } from "@/assets/images";
import { HANDLE } from "../config";

// Top brand block: NAŠA.com logo + handle.
export const BrandHeader = ({ showHandle = true }) => (
  <div className="flex flex-col items-center gap-2 fade-up" data-testid="brand-header">
    <img
      src={LOGO_NASA}
      alt="NAŠA.com"
      style={{ width: 150, height: "auto", display: "block" }}
      data-testid="brand-logo"
    />
    {showHandle && (
      <div
        data-testid="brand-handle"
        style={{ fontWeight: 600, letterSpacing: "0.01em" }}
      >
        {HANDLE}
      </div>
    )}
  </div>
);

export default BrandHeader;
